import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { HorizontalBar, Bar } from 'react-chartjs-2';
import { useLocation } from 'react-router-dom';

import {
  Box,
  Skeleton,
  useToast,
  useDisclosure,
  Text,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
// import { format, parseISO } from 'date-fns';
import queryString from 'query-string';

import { User } from '~/modules/accessControl/@types/user';
import { ActivityProps } from '~/modules/activityExecution/@types/activity';
import ModalReplan from '~/shared/components/Modal/ModalReplan';
import SectionHeader from '~/shared/components/SectionHeader';
import api from '~/shared/services/api';

import PlanningChart from '../../components/PlanningChart';

export interface WorkShift {
  primeiro_turno_entrada: string;
  primeiro_turno_saida: string;
  segundo_turno_entrada?: string;
  segundo_turno_saida?: string;
  tempo_disponivel?: string;
  full: boolean;
  total: string;
}

interface OverallocationData {
  user: User;
  overallocation: ActivityProps[];
  work_shift: WorkShift;
}

const Overallocation: React.FC = () => {
  const location = useLocation();
  const addToast = useToast();

  const { onOpen, isOpen, onClose } = useDisclosure();

  const queryParams = useMemo(() => {
    return queryString.parse(location.search);
  }, [location.search]);

  const selecteDate =
    queryParams?.data && typeof queryParams?.data === 'string'
      ? queryParams?.data
      : '';
  const funcId = queryParams?.func;

  const [loading, setLoading] = useState(true);
  const [selectedActivity, setSelectedActivity] = useState<ActivityProps>();

  const [overallocation, setOverallocation] = useState<ActivityProps[]>([]);
  const [workShift, setWorkshift] = useState<WorkShift>({} as WorkShift);
  const [employee, setEmployee] = useState<User>({} as User);
  const [reload, setReload] = useState(0);

  /* const date = useMemo(() => {
    if (typeof selecteDate === 'string')
      format(parseISO(selecteDate), 'dd/MM/yyyy');
  }, [selecteDate]); */

  useEffect(() => {
    // console.log(startTime);

    if (!selecteDate || !queryParams?.func) return;

    api
      .get<OverallocationData>('overallocation', {
        params: {
          employee_id: queryParams.func,
          date: selecteDate,
        },
      })
      .then((response) => {
        const { data } = response;

        setEmployee(data.user);
        setOverallocation(data.overallocation);
        setWorkshift(data.work_shift);
      })
      .catch((err) => {
        addToast({
          position: 'top-right',
          isClosable: true,
          status: 'error',
          title: 'Ooops!!!',
          description:
            err.response.data?.error || 'Ocorreu um erro, tente novamente.',
        });
      })
      .finally(() => setLoading(false));
  }, [queryParams, selecteDate, addToast, reload]);

  return (
    <Box>
      <SectionHeader
        title="Superalocação"
        pagename="Visualize as atividades que estão sobrepostas através do gráfico de Gantt"
        goBackPage
      />

      {/* {loading ? (
        <Box w="full">
          <Skeleton height="500px" width="calc(100% - 30px)" />
        </Box>
      ) : ( */}
      <>
        <PlanningChart
          employee={employee}
          date={selecteDate}
          plannings={overallocation}
          startTimeAxis={workShift?.primeiro_turno_entrada}
          endTimeAxis={
            workShift.full && workShift.segundo_turno_saida
              ? workShift.segundo_turno_saida
              : workShift.primeiro_turno_saida
          }
          loading={loading}
          selectChart={(idx) => {
            /* console.log(overallocation[idx]); */
            setSelectedActivity(overallocation[idx]);
            onOpen();
          }}
        />
      </>

      {selectedActivity && (
        <ModalReplan
          planning={selectedActivity}
          isOpen={isOpen}
          onClose={onClose}
          updated={() => setReload(reload + 1)}
        />
      )}
    </Box>
  );
};

export default Overallocation;
